import { HttpStatusCode, isAxiosError } from 'axios';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { projects, setProjectId } = useHttpClientStore();
  // const uiStore = useUiStore();
  const projectAuthZStore = useProjectAuthZStore();

  let isProjectAccessible = false;
  setProjectId(to.params.id as string);

  try {
    await projects.getOne(to.params.id as string);
    projectAuthZStore.isProjectLocked = false;
    isProjectAccessible = true;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      // If the project is not found, we assume it is not accessible
      if (error.response.status === HttpStatusCode.NotFound) {
        projectAuthZStore.isProjectLocked = true;
        projectAuthZStore.projectAccessControlPolicy = null;
        throw createError({
          statusCode: 404,
          statusMessage: 'Page Not Found',
        });
      } else if (error.response.status === HttpStatusCode.Unauthorized) {
        // We accept prefetch requests to the project
        console.warn('Password required for project:', to.params.id);
      }
    } else {
      console.error('Error fetching project:', error);
    }
  }
  try {
    const response = await projects.getProjectAccessControlPolicy(to.params.id as string);
    projectAuthZStore.projectAccessControlPolicy = response.data;
    projectAuthZStore.isProjectLocked =
      !isProjectAccessible && !response.data.isOwner && response.data.isPasswordProtected;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      let isExpectedError = false;
      // For existing project there is no access control policy
      if (error.response && error.response.status === HttpStatusCode.NotFound) {
        projectAuthZStore.projectAccessControlPolicy = null;
        projectAuthZStore.isProjectLocked = false;
        isExpectedError = true;
      }
      if (!isExpectedError) throw error;
    } else {
      throw error;
    }
  }
});
